import { render, staticRenderFns } from "./CardsSection.vue?vue&type=template&id=8417e420&scoped=true&"
import script from "./CardsSection.vue?vue&type=script&lang=js&"
export * from "./CardsSection.vue?vue&type=script&lang=js&"
import style0 from "./CardsSection.vue?vue&type=style&index=0&id=8417e420&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8417e420",
  null
  
)

export default component.exports